"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAthleteStencil = exports.athleteStencilDefinition = void 0;
const properties_1 = require("../properties");
const no_monetization_property_1 = require("../properties/no-monetization.property");
const participating_disciplines_property_1 = require("../properties/participating-disciplines.property");
const partner_profiles_property_1 = require("../properties/partner-profiles.property");
const product_related_image_property_1 = require("../properties/product-related-image.property");
const product_related_quote_property_1 = require("../properties/product-related-quote.property");
const seo_title_property_1 = require("../properties/seo-title.property");
const social_links_property_1 = require("../properties/social-links.property");
const social_title_property_1 = require("../properties/social-title.property");
const social_wall_property_1 = require("../properties/social-wall.property");
const soft_facts_property_1 = require("../properties/soft-facts.property");
const sound_bite_property_1 = require("../properties/sound-bite.property");
const subheading_property_1 = require("../properties/subheading.property");
const surname_property_1 = require("../properties/surname.property");
const track_records_property_1 = require("../properties/track-records.property");
const uri_title_property_1 = require("../properties/uri-title.property");
const url_property_1 = require("../properties/url.property");
const website_property_1 = require("../properties/website.property");
const speedweekContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'subheading',
            'teaser',
            'bio',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'uri-title',
                    'url',
                    'featured-media',
                    'featured-video',
                    'backdrop-media',
                ],
            },
            {
                name: 'Hard facts',
                items: [
                    'gender',
                    'first-name',
                    'surname',
                    'sound-bite',
                    'product-related-quote',
                    'product-related-image',
                    'date-of-birth',
                    'place-of-birth',
                    'location-of-nationality',
                    'participating-disciplines',
                    'career-start',
                    'height',
                    'weight',
                    'date-of-death',
                ],
            },
            {
                name: 'Soft facts',
                items: ['soft-facts'],
            },
            {
                name: 'Track records',
                items: ['track-records'],
            },
            {
                name: 'Social links',
                items: [
                    'social-links',
                    'social-wall',
                    'website',
                ],
            },
            {
                name: 'Partners',
                items: ['partner-profiles'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'standalone',
                    'no-monetization',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
            'related-content',
        ],
    },
];
exports.athleteStencilDefinition = {
    view: {
        label: 'Athlete',
        category: 'person',
        group: 'Persons & Groups',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'bio',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'featured-video',
                            'backdrop-media',
                        ],
                    },
                    {
                        name: 'Hard facts',
                        items: [
                            'gender',
                            'first-name',
                            'surname',
                            'sound-bite',
                            'product-related-quote',
                            'product-related-image',
                            'date-of-birth',
                            'place-of-birth',
                            'location-of-nationality',
                            'participating-disciplines',
                            'career-start',
                        ],
                    },
                    {
                        name: 'Soft facts',
                        items: ['soft-facts'],
                    },
                    {
                        name: 'Track records',
                        items: ['track-records'],
                    },
                    {
                        name: 'Social links',
                        items: [
                            'social-links',
                            'social-wall',
                            'website',
                        ],
                    },
                    {
                        name: 'Partners',
                        items: ['partner-profiles'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'backdrop-media': properties_1.backdropMediaPropertyDefinition,
        bio: properties_1.bioPropertyDefinition,
        'career-start': properties_1.careerStartPropertyDefinition,
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        'date-of-birth': properties_1.dateOfBirthPropertyDefinition,
        [properties_1.dateOfDeathPropertyDefinition.name]: properties_1.dateOfDeathPropertyDefinition,
        disciplines: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                properties_1.disciplinesPropertyDefinition.constraints[0],
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'featured-video': properties_1.featuredVideoPropertyDefinition,
        'first-name': properties_1.firstNamePropertyDefinition,
        gender: properties_1.genderPropertyDefinition,
        'header-media': {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        [properties_1.heightPropertyDefinition.name]: properties_1.heightPropertyDefinition,
        'location-of-nationality': properties_1.locationOfNationalityPropertyDefinition,
        'no-monetization': no_monetization_property_1.noMonetizationPropertyDefinition,
        'participating-disciplines': participating_disciplines_property_1.participatingDisciplinesPropertyDefinition,
        'partner-profiles': partner_profiles_property_1.partnerProfilesPropertyDefinition,
        'place-of-birth': properties_1.placeOfBirthPropertyDefinition,
        'product-related-image': product_related_image_property_1.productRelatedImagePropertyDefinition,
        'product-related-quote': product_related_quote_property_1.productRelatedQuotePropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        'seo-title': seo_title_property_1.seoTitlePropertyDefinition,
        'social-links': social_links_property_1.socialLinksPropertyDefinition,
        'social-title': social_title_property_1.socialTitlePropertyDefinition,
        'social-wall': social_wall_property_1.socialWallPropertyDefinition,
        'soft-facts': soft_facts_property_1.softFactsPropertyDefinition,
        'sound-bite': sound_bite_property_1.soundBitePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        subheading: subheading_property_1.subheadingPropertyDefinition,
        surname: surname_property_1.surnamePropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        title: properties_1.titlePropertyDefinition,
        'track-records': track_records_property_1.trackRecordsPropertyDefinition,
        'uri-title': uri_title_property_1.uriTitlePropertyDefinition,
        url: url_property_1.urlPropertyDefinition,
        website: website_property_1.websitePropertyDefinition,
        [properties_1.weightPropertyDefinition.name]: properties_1.weightPropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'global',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull_com',
        'redbull-advancedtechnologies',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'speedweek',
        'wingfinder',
        'xalps',
    ],
    name: 'athlete',
    overwrites: [
        {
            condition: 'space',
            argument: 'speedweek',
            contentAreas: speedweekContentAreas,
        },
    ],
};
const isAthleteStencil = (stencil) => {
    return stencil.name === exports.athleteStencilDefinition.name;
};
exports.isAthleteStencil = isAthleteStencil;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXRobGV0ZS5zdGVuY2lsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0ZW5jaWxzL2F0aGxldGUuc3RlbmNpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFHQSw4Q0E0QnNCO0FBQ3RCLHFGQUF5RjtBQUN6Rix5R0FBNkc7QUFDN0csdUZBQTJGO0FBQzNGLGlHQUFvRztBQUNwRyxpR0FBb0c7QUFDcEcseUVBQTZFO0FBQzdFLCtFQUFtRjtBQUNuRiwrRUFBbUY7QUFDbkYsNkVBQWlGO0FBQ2pGLDJFQUErRTtBQUMvRSwyRUFBK0U7QUFDL0UsMkVBQWdGO0FBQ2hGLHFFQUEwRTtBQUMxRSxpRkFBcUY7QUFDckYseUVBQTZFO0FBQzdFLDZEQUFrRTtBQUNsRSxxRUFBMEU7QUFFMUUsTUFBTSxxQkFBcUIsR0FBa0I7SUFDM0M7UUFDRSxJQUFJLEVBQUUsTUFBTTtRQUNaLEtBQUssRUFBRTtZQUNMLGNBQWM7WUFDZCxPQUFPO1lBQ1AsWUFBWTtZQUNaLFFBQVE7WUFDUixLQUFLO1NBQ047S0FDRjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE1BQU07UUFDWixRQUFRLEVBQUU7WUFDUjtnQkFDRSxJQUFJLEVBQUUsU0FBUztnQkFDZixLQUFLLEVBQUU7b0JBQ0wsV0FBVztvQkFDWCxjQUFjO29CQUNkLGdCQUFnQjtvQkFDaEIsV0FBVztvQkFDWCxLQUFLO29CQUNMLGdCQUFnQjtvQkFDaEIsZ0JBQWdCO29CQUNoQixnQkFBZ0I7aUJBQ2pCO2FBQ0Y7WUFDRDtnQkFDRSxJQUFJLEVBQUUsWUFBWTtnQkFDbEIsS0FBSyxFQUFFO29CQUNMLFFBQVE7b0JBQ1IsWUFBWTtvQkFDWixTQUFTO29CQUNULFlBQVk7b0JBQ1osdUJBQXVCO29CQUN2Qix1QkFBdUI7b0JBQ3ZCLGVBQWU7b0JBQ2YsZ0JBQWdCO29CQUNoQix5QkFBeUI7b0JBQ3pCLDJCQUEyQjtvQkFDM0IsY0FBYztvQkFDZCxRQUFRO29CQUNSLFFBQVE7b0JBQ1IsZUFBZTtpQkFDaEI7YUFDRjtZQUNEO2dCQUNFLElBQUksRUFBRSxZQUFZO2dCQUNsQixLQUFLLEVBQUUsQ0FBQyxZQUFZLENBQUM7YUFDdEI7WUFDRDtnQkFDRSxJQUFJLEVBQUUsZUFBZTtnQkFDckIsS0FBSyxFQUFFLENBQUMsZUFBZSxDQUFDO2FBQ3pCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLGNBQWM7Z0JBQ3BCLEtBQUssRUFBRTtvQkFDTCxjQUFjO29CQUNkLGFBQWE7b0JBQ2IsU0FBUztpQkFDVjthQUNGO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLFVBQVU7Z0JBQ2hCLEtBQUssRUFBRSxDQUFDLGtCQUFrQixDQUFDO2FBQzVCO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLFVBQVU7Z0JBQ2hCLEtBQUssRUFBRTtvQkFDTCxjQUFjO29CQUNkLFlBQVk7b0JBQ1osaUJBQWlCO2lCQUNsQjthQUNGO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLG1CQUFtQjtnQkFDekIsS0FBSyxFQUFFLENBQUMsc0JBQXNCLENBQUM7YUFDaEM7U0FDRjtLQUNGO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsU0FBUztRQUNmLEtBQUssRUFBRTtZQUNMLGFBQWE7WUFDYixvQkFBb0I7WUFDcEIsWUFBWTtZQUNaLGtCQUFrQjtZQUNsQixhQUFhO1lBQ2IsV0FBVztZQUNYLGlCQUFpQjtTQUNsQjtLQUNGO0NBQ0YsQ0FBQTtBQUVZLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFNBQVM7UUFDaEIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsS0FBSyxFQUFFLGtCQUFrQjtRQUN6QixVQUFVLEVBQUUsQ0FBQyxPQUFPLENBQUM7UUFDckIsVUFBVSxFQUFFLENBQUMsZ0JBQWdCLENBQUM7UUFDOUIsWUFBWSxFQUFFO1lBQ1o7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osS0FBSyxFQUFFO29CQUNMLGNBQWM7b0JBQ2QsT0FBTztvQkFDUCxZQUFZO29CQUNaLFFBQVE7b0JBQ1IsS0FBSztpQkFDTjthQUNGO1lBQ0Q7Z0JBQ0UsSUFBSSxFQUFFLE1BQU07Z0JBQ1osUUFBUSxFQUFFO29CQUNSO3dCQUNFLElBQUksRUFBRSxTQUFTO3dCQUNmLEtBQUssRUFBRTs0QkFDTCxXQUFXOzRCQUNYLGNBQWM7NEJBQ2QsZ0JBQWdCOzRCQUNoQixXQUFXOzRCQUNYLEtBQUs7NEJBQ0wsZ0JBQWdCOzRCQUNoQixnQkFBZ0I7NEJBQ2hCLGdCQUFnQjt5QkFDakI7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFlBQVk7d0JBQ2xCLEtBQUssRUFBRTs0QkFDTCxRQUFROzRCQUNSLFlBQVk7NEJBQ1osU0FBUzs0QkFDVCxZQUFZOzRCQUNaLHVCQUF1Qjs0QkFDdkIsdUJBQXVCOzRCQUN2QixlQUFlOzRCQUNmLGdCQUFnQjs0QkFDaEIseUJBQXlCOzRCQUN6QiwyQkFBMkI7NEJBQzNCLGNBQWM7eUJBQ2Y7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLFlBQVk7d0JBQ2xCLEtBQUssRUFBRSxDQUFDLFlBQVksQ0FBQztxQkFDdEI7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLGVBQWU7d0JBQ3JCLEtBQUssRUFBRSxDQUFDLGVBQWUsQ0FBQztxQkFDekI7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLGNBQWM7d0JBQ3BCLEtBQUssRUFBRTs0QkFDTCxjQUFjOzRCQUNkLGFBQWE7NEJBQ2IsU0FBUzt5QkFDVjtxQkFDRjtvQkFDRDt3QkFDRSxJQUFJLEVBQUUsVUFBVTt3QkFDaEIsS0FBSyxFQUFFLENBQUMsa0JBQWtCLENBQUM7cUJBQzVCO29CQUNEO3dCQUNFLElBQUksRUFBRSxVQUFVO3dCQUNoQixLQUFLLEVBQUU7NEJBQ0wsY0FBYzs0QkFDZCxZQUFZOzRCQUNaLGlCQUFpQjt5QkFDbEI7cUJBQ0Y7b0JBQ0Q7d0JBQ0UsSUFBSSxFQUFFLG1CQUFtQjt3QkFDekIsS0FBSyxFQUFFLENBQUMsc0JBQXNCLENBQUM7cUJBQ2hDO2lCQUNGO2FBQ0Y7WUFDRDtnQkFDRSxJQUFJLEVBQUUsU0FBUztnQkFDZixLQUFLLEVBQUU7b0JBQ0wsYUFBYTtvQkFDYixvQkFBb0I7b0JBQ3BCLFlBQVk7b0JBQ1osa0JBQWtCO29CQUNsQixhQUFhO29CQUNiLFdBQVc7b0JBQ1gsaUJBQWlCO2lCQUNsQjthQUNGO1NBQ0Y7UUFDRCxvQkFBb0IsRUFBRTtZQUNwQixjQUFjLEVBQUUsSUFBSTtZQUNwQixxQkFBcUIsRUFBRSxJQUFJO1NBQzVCO0tBQ0Y7SUFDRCxPQUFPLEVBQUU7UUFDUCxnQkFBZ0IsRUFBRSw0Q0FBK0I7UUFDakQsR0FBRyxFQUFFLGtDQUFxQjtRQUMxQixjQUFjLEVBQUUsMENBQTZCO1FBQzdDLG9CQUFvQixFQUFFLGdEQUFtQztRQUN6RCxlQUFlLEVBQUUsMENBQTZCO1FBQzlDLENBQUMsMENBQTZCLENBQUMsSUFBSSxDQUFDLEVBQUUsMENBQTZCO1FBQ25FLFdBQVcsRUFBRTtZQUNYLEdBQUcsMENBQTZCO1lBQ2hDLFdBQVcsRUFBRTtnQkFDWCwwQ0FBNkIsQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDO2dCQUM1QztvQkFDRSxJQUFJLEVBQUUsVUFBVTtvQkFDaEIsUUFBUSxFQUFFLElBQUk7aUJBQ2Y7Z0JBQ0Q7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLFFBQVEsRUFBRSxDQUFDLFlBQVksQ0FBQztpQkFDekI7YUFDRjtTQUNGO1FBQ0QsZ0JBQWdCLEVBQUUsNENBQStCO1FBQ2pELGdCQUFnQixFQUFFLDRDQUErQjtRQUNqRCxnQkFBZ0IsRUFBRSw0Q0FBK0I7UUFDakQsWUFBWSxFQUFFLHdDQUEyQjtRQUN6QyxNQUFNLEVBQUUscUNBQXdCO1FBQ2hDLGNBQWMsRUFBRTtZQUNkLEdBQUcsMENBQTZCO1lBQ2hDLFdBQVcsRUFBRTtnQkFDWDtvQkFDRSxJQUFJLEVBQUUsVUFBVTtvQkFDaEIsUUFBUSxFQUFFLElBQUk7aUJBQ2Y7Z0JBQ0Q7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLFFBQVEsRUFBRTt3QkFDUixPQUFPO3dCQUNQLE9BQU87d0JBQ1AsZUFBZTt3QkFDZixNQUFNO3dCQUNOLGFBQWE7d0JBQ2IsZUFBZTt3QkFDZixlQUFlO3FCQUNoQjtpQkFDRjthQUNGO1NBQ0Y7UUFDRCxDQUFDLHFDQUF3QixDQUFDLElBQUksQ0FBQyxFQUFFLHFDQUF3QjtRQUN6RCx5QkFBeUIsRUFBRSxvREFBdUM7UUFDbEUsaUJBQWlCLEVBQUUsMkRBQWdDO1FBQ25ELDJCQUEyQixFQUFFLCtFQUEwQztRQUN2RSxrQkFBa0IsRUFBRSw2REFBaUM7UUFDckQsZ0JBQWdCLEVBQUUsMkNBQThCO1FBQ2hELHVCQUF1QixFQUFFLHNFQUFxQztRQUM5RCx1QkFBdUIsRUFBRSxzRUFBcUM7UUFDOUQsc0JBQXNCLEVBQUUsa0RBQXFDO1FBQzdELGlCQUFpQixFQUFFLDZDQUFnQztRQUNuRCxjQUFjLEVBQUUsMENBQTZCO1FBQzdDLFdBQVcsRUFBRSwrQ0FBMEI7UUFDdkMsY0FBYyxFQUFFLHFEQUE2QjtRQUM3QyxjQUFjLEVBQUUscURBQTZCO1FBQzdDLGFBQWEsRUFBRSxtREFBNEI7UUFDM0MsWUFBWSxFQUFFLGlEQUEyQjtRQUN6QyxZQUFZLEVBQUUsaURBQTJCO1FBQ3pDLFVBQVUsRUFBRTtZQUNWLEdBQUcseUNBQTRCO1lBQy9CLE9BQU8sRUFBRSxJQUFJO1NBQ2Q7UUFDRCxVQUFVLEVBQUUsa0RBQTRCO1FBQ3hDLE9BQU8sRUFBRSw0Q0FBeUI7UUFDbEMsa0JBQWtCLEVBQUUsNkNBQWdDO1FBQ3BELFlBQVksRUFBRSx3Q0FBMkI7UUFDekMsYUFBYSxFQUFFLHlDQUE0QjtRQUMzQyxXQUFXLEVBQUUsdUNBQTBCO1FBQ3ZDLE1BQU0sRUFBRSxxQ0FBd0I7UUFDaEMsS0FBSyxFQUFFLG9DQUF1QjtRQUM5QixlQUFlLEVBQUUsdURBQThCO1FBQy9DLFdBQVcsRUFBRSwrQ0FBMEI7UUFDdkMsR0FBRyxFQUFFLG9DQUFxQjtRQUMxQixPQUFPLEVBQUUsNENBQXlCO1FBQ2xDLENBQUMscUNBQXdCLENBQUMsSUFBSSxDQUFDLEVBQUUscUNBQXdCO0tBQzFEO0lBQ0QsYUFBYSxFQUFFLEVBQUU7SUFDakIsS0FBSyxFQUFFLEVBQUU7SUFDVCxNQUFNLEVBQUU7UUFDTixTQUFTO1FBQ1QsU0FBUztRQUNULHVCQUF1QjtRQUN2QixRQUFRO1FBQ1IsYUFBYTtRQUNiLGNBQWM7UUFDZCxlQUFlO1FBQ2YsWUFBWTtRQUNaLGFBQWE7UUFDYiw4QkFBOEI7UUFDOUIsbUJBQW1CO1FBQ25CLHFCQUFxQjtRQUNyQixnQkFBZ0I7UUFDaEIsbUJBQW1CO1FBQ25CLGFBQWE7UUFDYixjQUFjO1FBQ2QsV0FBVztRQUNYLFlBQVk7UUFDWixPQUFPO0tBQ1I7SUFDRCxJQUFJLEVBQUUsU0FBUztJQUNmLFVBQVUsRUFBRTtRQUNWO1lBQ0UsU0FBUyxFQUFFLE9BQU87WUFDbEIsUUFBUSxFQUFFLFdBQVc7WUFDckIsWUFBWSxFQUFFLHFCQUFxQjtTQUNwQztLQUNGO0NBQzZCLENBQUE7QUFJekIsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLE9BQW9CLEVBQTZCLEVBQUU7SUFDbEYsT0FBTyxPQUFPLENBQUMsSUFBSSxLQUFLLGdDQUF3QixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLGdCQUFnQixvQkFFNUIifQ==